// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__fIzsK","footer":"ModalInfo_footer__3WIz9"};